module.exports = __webpack_public_path__ + "img/Ablast_1280x1010.984a139f.jpg";